module.exports = __webpack_public_path__ + "static/media/user-avatar.5bded05c.jpg";